var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReinforcementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.618,
    height: 33.662,
    viewBox: "0 0 40.618 33.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-1 -147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11864",
    "data-name": "Path 11864",
    d: "M40.9,1273.429H1.715a.7.7,0,0,1-.715-.715.717.717,0,0,1,.715-.715H40.9a.717.717,0,0,1,.715.715A.7.7,0,0,1,40.9,1273.429Z",
    transform: "translate(0 -1098.199)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11865",
    "data-name": "Path 11865",
    d: "M224.708,1387.429H194.715a.7.7,0,0,1-.715-.714.717.717,0,0,1,.715-.715h29.993a.733.733,0,0,1,.715.715A.717.717,0,0,1,224.708,1387.429Z",
    transform: "translate(-188.402 -1209.483)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11866",
    "data-name": "Path 11866",
    d: "M365.656,1501.429H342.715a.717.717,0,0,1-.715-.715.7.7,0,0,1,.715-.715h22.941a.717.717,0,0,1,.715.715A.733.733,0,0,1,365.656,1501.429Z",
    transform: "translate(-332.876 -1320.767)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11867",
    "data-name": "Path 11867",
    d: "M96.14,581.32H59.715a.7.7,0,0,1-.715-.715v-16.89a.717.717,0,0,1,.715-.715H65a.717.717,0,0,1,.715.715v7.742h8.29a.7.7,0,0,1,.715.715v7.719h6.408v-7.719a.7.7,0,0,1,.715-.715h8.267v-7.742a.733.733,0,0,1,.715-.715H96.14a.717.717,0,0,1,.715.715v16.89A.7.7,0,0,1,96.14,581.32Zm-32.876-2.43a.406.406,0,0,0,0-.81H62.192a.4.4,0,1,0,0,.81Zm30.4-6.623a.382.382,0,0,0,.381-.4v-5.551a.4.4,0,0,0-.381-.4.4.4,0,0,0-.4.4v5.551A.4.4,0,0,0,93.662,572.267Zm0,2.43a.406.406,0,0,0,0-.81H92.59a.4.4,0,0,0,0,.81Zm-4.145,0a.4.4,0,0,0,0-.81H88.445a.406.406,0,0,0,0,.81Zm-4.121,0a.406.406,0,0,0,0-.81H84.324a.4.4,0,0,0,0,.81Zm8.267,2.1a.406.406,0,0,0,0-.81H92.59a.4.4,0,0,0,0,.81Zm-4.145,0a.4.4,0,0,0,0-.81H88.445a.406.406,0,0,0,0,.81Zm-4.121,0a.406.406,0,0,0,0-.81H84.324a.4.4,0,0,0,0,.81Zm8.267,2.1a.406.406,0,0,0,0-.81H92.59a.4.4,0,1,0,0,.81Zm-4.145,0a.4.4,0,1,0,0-.81H88.445a.406.406,0,0,0,0,.81Zm-4.121,0a.406.406,0,0,0,0-.81H84.324a.4.4,0,1,0,0,.81Zm-23.2-6.623a.417.417,0,0,0,.4-.4v-5.551a.417.417,0,0,0-.4-.4.4.4,0,0,0-.381.4v5.551A.4.4,0,0,0,62.192,572.267Zm9.339,2.43a.406.406,0,0,0,0-.81H70.459a.4.4,0,0,0,0,.81Zm-4.145,0a.4.4,0,0,0,0-.81H66.337a.4.4,0,0,0,0,.81Zm-4.121,0a.406.406,0,0,0,0-.81H62.192a.4.4,0,0,0,0,.81Zm8.267,2.1a.406.406,0,0,0,0-.81H70.459a.4.4,0,0,0,0,.81Zm-4.145,0a.4.4,0,0,0,0-.81H66.337a.4.4,0,0,0,0,.81Zm-4.121,0a.406.406,0,0,0,0-.81H62.192a.4.4,0,0,0,0,.81Zm8.267,2.1a.406.406,0,0,0,0-.81H70.459a.4.4,0,1,0,0,.81Zm-4.145,0a.4.4,0,1,0,0-.81H66.337a.4.4,0,1,0,0,.81Z",
    transform: "translate(-56.618 -406.09)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11868",
    "data-name": "Path 11868",
    d: "M298.557,175.23H290.72a.717.717,0,0,1-.715-.715V166.8h-8.29a.733.733,0,0,1-.715-.715V147.715a.717.717,0,0,1,.715-.715h3.192a.717.717,0,0,1,.715.715v3.6a.733.733,0,0,1-.715.715.717.717,0,0,1-.715-.715v-2.883h-1.763v16.938h8.29a.7.7,0,0,1,.715.715V173.8h6.408v-7.719a.7.7,0,0,1,.715-.715h8.267V148.429h-1.739v2.883a.717.717,0,0,1-.715.715.733.733,0,0,1-.715-.715v-3.6a.717.717,0,0,1,.715-.715h3.168a.7.7,0,0,1,.715.715v18.367a.717.717,0,0,1-.715.715h-8.267v7.719A.733.733,0,0,1,298.557,175.23Z",
    transform: "translate(-273.33)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11869",
    "data-name": "Path 11869",
    d: "M435.178,299.429H415.715a.717.717,0,0,1-.715-.715.7.7,0,0,1,.715-.715h19.463a.7.7,0,0,1,.715.715A.717.717,0,0,1,435.178,299.429Z",
    transform: "translate(-404.137 -147.403)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11870",
    "data-name": "Path 11870",
    d: "M307.539,442.429H281.715a.717.717,0,0,1-.715-.715.733.733,0,0,1,.715-.715h25.824a.717.717,0,0,1,.715.715A.7.7,0,0,1,307.539,442.429Z",
    transform: "translate(-273.33 -286.996)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11871",
    "data-name": "Path 11871",
    d: "M307.539,610.429H281.715a.717.717,0,0,1-.715-.715.733.733,0,0,1,.715-.715h25.824a.717.717,0,0,1,.715.715A.7.7,0,0,1,307.539,610.429Z",
    transform: "translate(-273.33 -450.994)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11872",
    "data-name": "Path 11872",
    d: "M1108.714,241.962a.733.733,0,0,1-.715-.715V224.715a.717.717,0,0,1,.715-.715.7.7,0,0,1,.715.715v16.533A.717.717,0,0,1,1108.714,241.962Z",
    transform: "translate(-1080.628 -75.166)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11873",
    "data-name": "Path 11873",
    d: "M823.715,250.4a.717.717,0,0,1-.715-.715V224.715a.717.717,0,0,1,.715-.715.7.7,0,0,1,.715.715v24.966A.7.7,0,0,1,823.715,250.4Z",
    transform: "translate(-802.418 -75.166)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11874",
    "data-name": "Path 11874",
    d: "M538.715,241.962a.733.733,0,0,1-.715-.715V224.715a.717.717,0,0,1,.715-.715.7.7,0,0,1,.715.715v16.533A.717.717,0,0,1,538.715,241.962Z",
    transform: "translate(-524.207 -75.166)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11875",
    "data-name": "Path 11875",
    d: "M307.539,778.429H281.715a.717.717,0,0,1-.715-.715.733.733,0,0,1,.715-.715h25.824a.717.717,0,0,1,.715.715A.7.7,0,0,1,307.539,778.429Z",
    transform: "translate(-273.33 -614.992)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11876",
    "data-name": "Path 11876",
    d: "M667.552,986.429h-7.838a.733.733,0,0,1-.715-.715.717.717,0,0,1,.715-.715h7.838a.7.7,0,0,1,.691.715A.712.712,0,0,1,667.552,986.429Z",
    transform: "translate(-642.325 -818.036)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11877",
    "data-name": "Path 11877",
    d: "M667.552,1138.429h-7.838a.733.733,0,0,1-.715-.715.717.717,0,0,1,.715-.714h7.838a.7.7,0,0,1,.691.714A.712.712,0,0,1,667.552,1138.429Z",
    transform: "translate(-642.325 -966.415)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReinforcementIcon);
export default __webpack_public_path__ + "static/media/Reinforcement_icon.9447e962cf22dda945c6e8b7762b775e.svg";
export { ForwardRef as ReactComponent };